const diabetes= [

    { 
    label:"Type:",
    controlType:"radio button",
    options:["Insuliin dependent ", "Insulin controlled", "Tablet controlled","Diet Controlled"]
    },
        
    { 
    label:"Present for several:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }

]

export default diabetes